import web from "./service/web.js"
import wechat from "./service/wechat.js"
import ecommerce from "./service/ecommerce.js"
import crawler from "./service/crawler"

export default {
    web,wechat,ecommerce,crawler
}